// extracted by css-extract-rspack-plugin
export default {"buttonText":"ChooseNewOrExists__buttonText--AveXZ"};